<template>
    <div @click="goToDetail(item)" class="matchItem">
        <div class="top">
            <div class="avatar-wrap">
                <div class="img-wrap">
                    <img v-if="item.gender == 2" :src="item.avatarUrl | avatar('women')" v-img-error-user="2"
                         alt=""/>
                    <img v-else :src="item.avatarUrl | avatar('men')" v-img-error-user="1" alt=""/>
                </div>
                <b v-if="item.unReadCount" class="red-circle"></b>
            </div>
            <div class="info">
                <p>
                    <span class="title van-ellipsis">{{item.talentName}}</span>
                    <span class="salary" v-if="item.anualSalary">{{item.anualSalary | tenThousand}}</span>
                    <span class="btn-color-wrap btn-color-blue" v-if="item.homoCount && type != 'tab'">
                        <a class="btn-color" href="javascript:;">AI人岗匹配<span class="num">({{item.homoCount}})</span></a>
                    </span>
                </p>
                <div>
                    <div class="separate-info-list">
                        <span v-if="item.gender">{{item.gender | gender}}</span>
                        <span v-if="item.age">{{item.age}}岁</span>
                        <span v-if="item.workYear">{{item.workYear}}年</span>
                        <span v-if="item.city">{{item.city}}</span>
                    </div>
                    <span class="time" v-if="item.updateTimeDesc">{{item.updateTimeDesc}}</span>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="separate-info-list">
                <span v-if="item.profession">{{item.profession}}</span>
                <span v-if="item.school">{{item.school}}</span>
                <span v-if="item.degreeName">{{item.degreeName}}</span>
            </div>
            <div class="separate-info-list">
                <span v-if="item.currentJobTitle">{{item.currentJobTitle}}</span>
                <span v-if="item.currentCompanyName">{{item.currentCompanyName}}</span>
            </div>
            <div class="tag-list" v-if="item.tags">
                <span class="tag" v-if="item.tags.is985">985</span>
                <span class="tag" v-if="item.tags.is211">211</span>
                <span class="tag" v-if="item.tags.famousCompany">名企</span>
                <span class="tag" v-if="item.tags.networkCompany">知名互联网公司</span>
                <span class="tag" v-if="item.tags.worldTop500">世界500强</span>
            </div>
        </div>
        <div class="flex-box" style="margin-top: 10px" v-if="positionId">
            <div class="stars-wrap">
                <p>人岗匹配度</p>
                <div class="star-rating">
                    <div :style="'width:' + (item.matchScore*100).toFixed(1) + '%'" class="star-rating-top">
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                    </div>
                    <div class="star-rating-bottom">
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <van-icon name="star"/>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                        <span><i class="iconfont icon-xing1"></i></span>
                    </div>
                </div>
            </div>
            <div class="data-wrap">
                <span class="data-list"><span class="green">{{item.matchCounts || 0}}</span>项匹配</span>
                <span class="data-list"><span class="red">{{item.unMatchCounts || 0}}</span>项不符</span>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "employerItem",
    props: {
      item: {
        default() {
          return {};
        }
      },
      type: ""
    },
    data() {
      return {
        positionId: this.$route.params.positionId || ""
      };
    },
    components: {},
    methods: {
      goToDetail(item) {
        if (this.type != "tab") {
          let url = "/aiMatch/matchDetail/" + this.item.talentId;
          this.$router.push(url);
        }
      }
    },
    created() {

    }
  };
</script>

<style lang="scss" scoped>

    .avatar-wrap{
        position: relative;
        .red-circle{
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: absolute;
            background: #FA3E25;
            top: 4px;
            right: 0;
        }
    }

    .btn-color-wrap {
        float: right;
    }

    .matchItem {
        padding: 15px;
        background: #fff;
        margin-bottom: 10px;

        .separate-info-list {
            font-size: 13px;
        }

        .top {
            padding-bottom: 10px;
            margin-bottom: 10px;
            border-bottom: .5px solid #E5E5E5;
            display: flex;

            .info {
                flex: 1;
                .time {
                    font-size: 12px;
                    color: #999999;
                    line-height: 20px;
                    float: right;
                }
                p {
                    line-height: 20px;
                    margin-bottom: 10px;
                    font-size: 12px;
                    color: #666666;
                    .title {
                        font-size: 16px;
                        color: #333333;
                        max-width: 200px;
                    }
                    .salary {
                        margin-left: 15px;
                        font-size: 14px;
                    }
                }
            }
        }

        .bottom {
            width: 100%;
            overflow: hidden;
            .separate-info-list {
                margin-bottom: 10px;
                float: none;
            }

        }

        .stars-wrap {
            flex: 1;
        }

        .data-wrap {
            margin-left: auto;
            display: flex;

            .data-list {
                margin-left: 20px;
                white-space: nowrap;
            }
        }
    }
</style>